<template>
	<el-dialog custom-class="dialog-content" title="添加佣金计划" :visible.sync="dialogVisible" width="480px" :before-close="handleClose">
		<div>
			<div class="form-item">
				<div class="form-label yx-color-text-primary fz-14">可分配服务费率</div>
				<div class="form-content">
					<div class="fz-14 yx-color-text-primary">{{ Number(allocationValueRate) ? Number(allocationValueRate) * 100 + '%' : '0%' }}</div>
				</div>
			</div>
			<div class="form-item">
				<div class="form-label yx-color-text-primary fz-14">佣金率</div>
				<div class="form-content flex flex-align-center">
					<el-input style="width: 150px" v-model="commissionRate" placeholder="请输入" @input="commissChange" min="0" max="90" />
					<span class="fz-12 yx-color-text-primary ml-8">%</span>
					<span style="color: #86909c; margin-left: 16px" class="fz-12">不可高于可分配服务费</span>
				</div>
			</div>
			<div class="form-item">
				<div class="form-label yx-color-text-primary fz-14">服务费率</div>
				<div class="form-content">
					<div class="fz-14 yx-color-text-primary">{{ serviceRate ? serviceRate.toFixed(2) + '%' : '0%' }}</div>
				</div>
			</div>
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="submit">确认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from 'lodash';
import { addCommissionPlan } from '@/api/shopManage';
export default {
	data() {
		return {
			dialogVisible: false,
			allocationValueRate: 0,
			commissionRate: 0,
			serviceRate: 0,
			form: {},
		};
	},
	methods: {
		show(info) {
			this.dialogVisible = true;
			this.form = info;
			this.allocationValueRate = info.originServiceRate;
		},

		// 正则只能输入整数数字
		commissChange(val) {
			this.commissionRate = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
			if (val >= Number(this.allocationValueRate) * 100) {
				this.commissionRate = Number(this.allocationValueRate) * 100;
			}
			//根据输入的分配比例自行计算。服务费率=可分配服务费率 * （100%-分配比例）。
			this.serviceRate = Number(this.allocationValueRate) * 100 - Number(this.commissionRate);
		},
		handleClose() {
			this.dialogVisible = false;
			this.allocationValueRate = 0;
			this.commissionRate = 0;
			this.serviceRate = 0;
		},
		submit: debounce(async function () {
			if (!this.commissionRate) {
				return this.$message.warning('请输入佣金比例');
			}
			let ratio = Number(this.commissionRate).toFixed(2);
			const { code, data } = await addCommissionPlan({
				authorityId: this.form.authorityId,
				productId: this.form.productId,
				thirdProductId: this.form.thirdProductId,
				cooperatePlanId: this.form.cooperatePlanId,
				shopId: this.form.shopId,
				ratio: Math.trunc(ratio),
			});
			if (code === 0) {
				if (data.success) {
					this.$message.success('添加成功');
					this.$emit('refresh');
				} else {
					this.$message.error(data.message);
				}
			}
			this.handleClose();
		}, 300),
	},
};
</script>
<style lang="less" scoped>
.form-item {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	.form-label {
		min-width: 98px;
		margin-right: 16px;
		text-align: right;
	}
}
</style>